/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import { Inline, Box, FlexRow, FlexCol } from 'sarsaparilla';

import { gnoment } from 'shared-ui/gnoment';
import { shouldUseSmallerGrid } from '../utils/layoutUtils';
import { LayoutControlContext } from './DetailedAvailabilityPageLayout';

const propTypes = {
    numOfCols: PropTypes.number,
    startDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    hasAreaData: PropTypes.bool,
};

export default function AvailabilityMonths({ numOfCols, startDate, hasAreaData = true }) {
    const contextValue = useContext(LayoutControlContext);
    const isSmallerGrid = shouldUseSmallerGrid(contextValue);

    const monthList = range(numOfCols).reduce((acc, i) => {
        const month = gnoment(startDate).add(i, 'day').format('MMMM');
        acc[month] = (acc[month] ?? 0) + 1;
        return acc;
    }, {});

    let cellSize = hasAreaData ? 5.5 : 6;
    if (isSmallerGrid) {
        cellSize = 15;
    }

    return (
        <Box className="pt-2" background="white">
            <Inline space="none" alignX="right">
                {Object.entries(monthList).map(([monthName, days]) => (
                    <Box
                        key={monthName}
                        className="mb-1 availability-month-label"
                        style={{
                            width: `calc(${cellSize * days}% - 2px)`,
                            minWidth: `${4.7 * days}rem`,
                        }}
                    >
                        <FlexRow justifyContent="center">
                            <FlexCol xs={3} className="month-cell">
                                {monthName}
                            </FlexCol>
                        </FlexRow>
                    </Box>
                ))}
            </Inline>
        </Box>
    );
}

AvailabilityMonths.propTypes = propTypes;
